__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/58d9e1e/_next/";